import React from 'react';

export const DiasInfo = ({datos}) => {
  const pintar = (porcentajeVsParametro, concepto) => {
    if (porcentajeVsParametro >= datos.parametrosById[concepto].escala[1]) {
      return 'textoVerde';
    }

    if (porcentajeVsParametro >= datos.parametrosById[concepto].escala[0]) {
      return 'textoAmarillo';
    }

    return 'textoRojo';
  };

  const performanceHighlight = {
    entrevista: pintar(datos.entrevistasVsParametro, 'entrevista'),
    llamada: pintar(datos.llamadasVsParametro, 'llamada'),
    procesado: pintar(datos.procesadosVsParametro, 'procesado'),
  };

  return (
    <>
      <div style={{display: 'flex', justifyContent: 'flex-start'}}>
        <div
          className={`dayinfo-element ${performanceHighlight.llamada}`}
          style={{flex: 3}}>
          <div style={{marginRight: 4}}>Filtros por día: </div>
          <div>
            {datos.llamadasPorDia < 1 ? '<1' : Math.round(datos.llamadasPorDia)}
          </div>
        </div>
        <div
          className={`dayinfo-element ${performanceHighlight.entrevista}`}
          style={{flex: 3}}>
          <div style={{marginRight: 4}}>Entrevistas por día: </div>
          <div>
            {datos.entrevistasPorDia < 1
              ? '<1'
              : Math.round(datos.entrevistasPorDia)}
          </div>
        </div>
        {datos.cantidadDiasSemana >= 5 && (
          <div
            className={`dayinfo-element ${performanceHighlight.procesado}`}
            style={{flex: 3}}>
            <div style={{marginRight: 4}}>Procesados por semana: </div>
            <div>
              {datos.procesadosPorSemana < 1
                ? '<1'
                : Math.round(datos.procesadosPorSemana)}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
